import React from "react";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { View, ViewType } from "@common/types/views/views";
import { WorkspaceEmailAliasKind } from "@common/constants/domains/receipts/constants";
import {
    emailAliasesViewConfig,
    EmailAliasColumn,
    EmailAliasRow,
} from "./emailAliasesViewConfig";

const receiptColumns: View["columns"] = [
    { id: EmailAliasColumn.LOCAL_PART },
    { id: EmailAliasColumn.LIMIT },
    { id: EmailAliasColumn.ACTIONS, options: { pin: "right" } },
];

const vendorColumns: View["columns"] = [
    { id: EmailAliasColumn.LOCAL_PART },
    { id: EmailAliasColumn.VENDOR },
    { id: EmailAliasColumn.LIMIT },
    { id: EmailAliasColumn.ACTIONS, options: { pin: "right" } },
];

function getDefaultView(kind: WorkspaceEmailAliasKind): View {
    return {
        type: ViewType.EMAIL_ALIAS,
        columns: kind === "receipts" ? receiptColumns : vendorColumns,
        filters: {},
        options: {
            selection: false,
            bulkActions: false,
        },
    };
}

interface EmailAliasesViewProps {
    data: EmailAliasRow[] | null;
    kind: WorkspaceEmailAliasKind;
    emptyBody: string;
}

export const EmailAliasesView: React.FC<EmailAliasesViewProps> = ({
    data,
    kind,
    emptyBody,
}) => (
    <ViewTable
        data={data}
        view={getDefaultView(kind)}
        config={emailAliasesViewConfig}
        emptyView={() => (
            <EmptyState header="No email aliases yet" body={emptyBody} />
        )}
        enableColumnResizing={false}
        outerBorder
    />
);
